import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';

interface AdminCustomerGroupState {
  excludedFilter: string[];
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}

const defaultColumnList = [
  {
    name: 'name',
    label_key: 'name',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 1,
  },
  {
    name: 'created_at',
    label_key: 'created_at',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 2,
  },
  {
    name: 'status',
    label_key: 'status',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'select',
    filter_placeholder: 'status_all',
    selectKey: 'status',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 3,
  },
];

const exportColumnList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));

const initialState: AdminCustomerGroupState = {
  excludedFilter: [],
  filterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminCustomerGroupSlice = createSlice({
  name: 'adminCustomerGroup',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setCustomerGroupTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      state.tableColumnList = action.payload;
    },
  },
});

export const {
  setFilterData,
  resetFilterData,
  setReloadTableData,
  setCustomerGroupTableColumnList,
} = adminCustomerGroupSlice.actions;

export default adminCustomerGroupSlice.reducer;
